import React, { useEffect, useState } from 'react';
import './SectionNav.css';

const sections = [
  { id: 'hero', label: 'Home' },
  { id: 'gallery', label: 'Portfolio' },
  { id: 'contact', label: 'Contact' },
];

const SectionNav = () => {
  const [activeId, setActiveId] = useState('hero');

  useEffect(() => {
    const elements = sections
      .map((s) => document.getElementById(s.id))
      .filter(Boolean);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleClick = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="section-nav" aria-label="Section navigation">
      {sections.map((s) => (
        <button
          key={s.id}
          type="button"
          className={`section-nav-dot ${activeId === s.id ? 'active' : ''}`}
          onClick={() => handleClick(s.id)}
          aria-label={`Go to ${s.label}`}
          aria-current={activeId === s.id}
        >
          <span className="section-nav-tooltip">{s.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default SectionNav;
